/*** IMPORTS FROM imports-loader ***/
var _ = require("tpl-shim/fake-lodash.js");

export default function(data) {
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '<div class="thumbnail-col thumbnail-wrapper" tipsy="' +
__e(data.model.get('display_filename')) +
'">\n  ';
 if (data.model.isPlayable()){ ;
__p += '\n    <div class="playable-asset-icon">\n      <img class="video-play-button-img" src="https://d3jozdooylvm2p.cloudfront.net/images/icons/play_icon_v2.png"/>\n    </div>\n  ';
 } else if (data.model.isPDF()) { ;
__p += '\n    <div class="pdf-icon-wrapper">\n      <img class="pdf-icon" src="https://d3jozdooylvm2p.cloudfront.net/images/icons/pdf_file_icon.png"/>\n    </div>\n  ';
 } else if (data.model.isPPT()) { ;
__p += '\n    <div class="pdf-icon-wrapper">\n      <img class="pdf-icon" src="/static/images/ppt_file_icon.png"/>\n    </div>\n  ';
 } else if (data.model.isHtmlPackage()) { ;
__p += '\n    <div class="pdf-icon-wrapper">\n      <img class="pdf-icon" src="/static/images/html_package_file_icon.png"/>\n    </div>\n  ';
 } else if (data.model.isOther()) { ;
__p += '\n    <div class="pdf-icon-wrapper">\n      <img class="pdf-icon" src="/static/images/other_file_icon.png"/>\n    </div>\n  ';
 } ;
__p += '\n</div>\n\n<div class="filename-col item-cell item-filename">\n  ' +
__e(data.model.get('display_filename')) +
'\n</div>\n\n<div class="type-col item-cell">\n  ' +
__e(data.humanDisplayableAssetType) +
'\n</div>\n\n<div class="uploaded-by-col item-cell">\n  ' +
__e(data.model.getUploadedBy()) +
'\n</div>\n\n<div class="last-modified-col item-cell">\n  ' +
__e(data.lastModifiedAtFormatted) +
'\n</div>\n\n';
 if (data.showSelectionOverlay){ ;
__p += '\n  <div class="view-or-select-overlay">\n    <div class="select-asset">\n      <span class="deselect-option">\n        Deselect\n      </span>\n      <span class="select-option">\n        Select\n      </span>\n    </div>\n    <div class="view-asset action-expand-asset">\n      View\n    </div>\n  </div>\n';
 } ;
__p += '\n';
return __p
}
